import { LigtheningIcon, FaceHappyIcon, LightBulbIcon, TrendUpIcon, CheckIcon, StarIcon, UsersIcon, GraduationIcon, RobotIcon, FileCheckIcon } from '@coachhubio/nova-icon';

export enum SectionIds {
  OVERVIEW = 'overview',
  ENGAGEMENT = 'engagement',
  SATISFACTION = 'satisfaction',
  IMPACT = 'impact',
  MULTI_RATER_FEEDBACK = 'multirater-feedback',
  INSIGHTSPLUS = 'insightsplus',
  CODEVHUBS = 'codevhubs',
  IMPACTPLUS = 'impactplus',
  LEARNING = 'learning',
  COMPANION = 'companion',
  SURVEY_RESULTS = 'survey-results',
}

const SectionProps = {
  [SectionIds.OVERVIEW]: {
    href: '/',
    icon: LightBulbIcon,
    id: 95,
    height: 2400
  },
  [SectionIds.ENGAGEMENT]: {
    href: '/engagement',
    icon: LigtheningIcon,
    id: 91,
    height: 3200
  },
  [SectionIds.SATISFACTION]: {
    href: '/satisfaction',
    icon: FaceHappyIcon,
    id: 93,
    height: 1700
  },
  [SectionIds.IMPACT]: {
    href: '/impact',
    icon: TrendUpIcon,
    id: 96,
    height: 3600
  },
  [SectionIds.MULTI_RATER_FEEDBACK]: {
    href: '/multirater-feedback',
    icon: CheckIcon
  },
  [SectionIds.INSIGHTSPLUS]: {
    href: '/insightsplus',
    icon: StarIcon
  },
  [SectionIds.CODEVHUBS]: {
    href: '/codevhubs',
    icon: UsersIcon
  },
  [SectionIds.IMPACTPLUS]: {
    href: '/impactplus',
    icon: TrendUpIcon
  },
  [SectionIds.LEARNING]: {
    href: '/learning',
    icon: GraduationIcon
  },
  [SectionIds.COMPANION]: {
    href: '/companion',
    icon: RobotIcon
  },
  [SectionIds.SURVEY_RESULTS]: {
    href: '/surveyresults',
    icon: FileCheckIcon
  }
}

export enum AISectionIds {
  AI_SATISFACTION = 'ai-satisfaction',
  AI_ENGAGEMENT = 'ai-engagement',
  AI_IMPACT = 'ai-impact'
}

const AISectionProps = {
  [AISectionIds.AI_ENGAGEMENT]: {
    href: '/ai-engagement',
    icon: LigtheningIcon
  },
  [AISectionIds.AI_SATISFACTION]: {
    href: '/ai-satisfaction',
    icon: FaceHappyIcon
  },
  [AISectionIds.AI_IMPACT]: {
    href: '/ai-impact',
    icon: TrendUpIcon
  }
}

export { SectionProps, AISectionProps };
